
/**
 * 추가 메타데이터
 */
export type GetMediaById200TwoMetadata = { [key: string]: unknown };
